// Header.jsx
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube, faFacebook, faInstagram, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import DirectorioModal from "../components/Directorio/DirectorioModal";


export default function Header() {
  const [directorioOpen, setDirectorioOpen] = useState(false);

  return (
    <>
      {/* ====== Redes Sociales ====== */}
      <div className="header-social d-flex justify-content-end gap-3 py-3 px-3">
        <button
          type="button"
          className="social-btn"
          title="Directorio general"
          aria-label="Directorio general"
          onClick={() => setDirectorioOpen(true)}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
        >
          <div className="social-icon-circle">
            <svg
              className="phone-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="4 4 13 15"
              fill="#a90786"
              width="18"
              height="18"
            >
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55-.45-1-1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
            </svg>
          </div>
        </button>

        <a href="https://www.youtube.com/channel/UCUBfUX_c54NfhhvZRzK0k1w" target="_blank" rel="noreferrer" className="social-btn">
          <div className="social-icon-circle"><FontAwesomeIcon icon={faYoutube} /></div>
        </a>

        <a href="https://twitter.com/ITETLAX" target="_blank" rel="noreferrer" className="social-btn">
          <div className="social-icon-circle"><FontAwesomeIcon icon={faXTwitter} /></div>
        </a>

        <a href="https://es-la.facebook.com/InstitutoTlaxcaltecadeElecciones/" target="_blank" rel="noreferrer" className="social-btn">
          <div className="social-icon-circle"><FontAwesomeIcon icon={faFacebook} /></div>
        </a>

        <a href="https://www.instagram.com/ite_tlaxcala" target="_blank" rel="noreferrer" className="social-btn">
          <div className="social-icon-circle"><FontAwesomeIcon icon={faInstagram} /></div>
        </a>
      </div>

{/* ====== Logo y Nombre centrados con más separación ====== */}
<div
  className="header-main d-flex align-items-center justify-content-center mx-5"
  style={{
    gap: "30rem",
    background: "linear-gradient(to bottom, #ffffff, #fefcf5)", // degradado blanco -> beige muy tenue
    padding: "2.5rem 1rem",
    borderBottom: "1px solid rgba(0,0,0,0.05)" // opcional, separa ligeramente del navbar
  }}
>
  <Link to="/">
    <img
      src="https://itetlax.org.mx/assets/img/logoite.webp"
      alt="Instituto Tlaxcalteca de Elecciones"
      className="header-logo img-fluid"
    />
  </Link>
  <h1 className="header-title mb-0">Instituto Tlaxcalteca de Elecciones</h1>
</div>


        {/* ====== Estilos internos ====== */}
        <style>{`
          .header-social {
            background-color: #a90786 !important;
          }

          .social-btn {
            text-decoration: none !important;
          }

          /* Botón más pequeño */
          .social-icon-circle {
            width: 28px !important;
            height: 28px !important;
            border-radius: 50% !important;
            background-color: #fff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            transition: all 0.2s ease !important;
          }

          .social-icon-circle svg, .social-icon-circle .svg-inline--fa {
            color: #a90786 !important;
            width: 14px !important;
            height: 14px !important;
          }

          .social-btn:hover .social-icon-circle {
            transform: scale(1.1) !important;
            box-shadow: 0 2px 8px rgba(0,0,0,0.25) !important;
          }

          .header-main {
            background-color: #fff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0 20px !important;
            padding: 2.5rem 1rem !important; 
          }

          .header-logo {
            max-height: 4em !important;
            transition: transform 0.2s ease !important;
          }

          .header-logo:hover {
            transform: scale(1.05) !important;
          }

          .header-title {
            font-size: 1.6rem !important;
            font-weight: 600 !important;
            color: #333 !important;
          }

          @media (max-width: 768px) {
            .header-main {
              flex-direction: column !important;
              align-items: center !important;
              margin: 0 10px !important;
              gap: 2rem !important;
              padding: 2rem 1rem !important;
            }

            /* Ocultar texto del instituto en móviles */
            .header-title {
              display: none !important;
            }
        `}</style>

        <DirectorioModal
          isOpen={directorioOpen}
          onClose={() => setDirectorioOpen(false)}
        />
      </>
    );
}
